import './bootstrap';

// Externals
import '@wwdev/bootstrap/index.js';
import '@wwdev/functions/index.js';
import './wwdev/forms/index';
import '@fancyapps/fancybox';
import './wwdev/lazysizes/index.js';
import './wwdev/webshop/index.js';
// import '@wwdev/myaccount/index.js';
import '@wwdev/register';
import '@wwdev/search';

// import './base/header';

import './externals/hamburgers.js';
import './components/alert';
import './components/expense';
import './vendor/preacher-declaration-request';

import './vendor/contentsupply';

import Calendar from './components/calendar';
let calendar = new Calendar();
$('.calendarevent-date').on('change', function(event) {
	let date = this.value;
	$('.calendarevent-timeslot').find('option').each(function() {
		if (this.value == '') {
			return;
		}
		if($(this).data('dates').includes(date)) {
			$(this).removeAttr('disabled').css({display: ''})
		} else {
			$(this).attr('disabled', 'disabled').css({display: 'none'})
		}

	});
	$('.calendarevent-timeslot').val('');

}).trigger('change');


import './wwdev/forms';
import './vendor/donation/form.js';

